export const QUESTION_TYPE_MAP = [
    {
        id: 0,
        text: "单选题"
    },
    {
        id: 1,
        text: "多选题"
    },
    // {
    //   id: 5,
    //   text: "不定项选择题"
    // },
    {
        id: 3,
        text: "判断题"
    },
    {
        id: 4,
        text: "填空题"
    },
    {
        id: 2,
        text: "问答题"
    },
    {
        id: 6,
        text: "材料题"
    }
];
